<template>
  <!-- BEGIN: Top Bar -->
  <div class="top-bar">
    <!-- BEGIN: Breadcrumb -->
    <div class="-intro-x breadcrumb mr-auto hidden sm:flex">
      <a href class>Application</a>
      <ChevronRightIcon class="breadcrumb__icon" />
      <a href class="breadcrumb--active">Dashboard</a>
    </div>
    <!-- END: Breadcrumb -->
    <!-- BEGIN: Search -->
<!--    <div class="intro-x relative mr-3 sm:mr-6">-->
<!--      <div class="search hidden sm:block">-->
<!--        <input-->
<!--          type="text"-->
<!--          class="search__input input placeholder-theme-13"-->
<!--          placeholder="Search..."-->
<!--          @focus="showSearchDropdown"-->
<!--          @blur="hideSearchDropdown"-->
<!--        />-->
<!--        <SearchIcon class="search__icon dark:text-gray-300" />-->
<!--      </div>-->
<!--      <a class="notification sm:hidden" href>-->
<!--        <SearchIcon class="notification__icon dark:text-gray-300" />-->
<!--      </a>-->
<!--      <div class="search-result" :class="{ show: searchDropdown }">-->
<!--        <div class="search-result__content">-->
<!--          <div class="search-result__content__title">Pages</div>-->
<!--          <div class="mb-5">-->
<!--            <a href class="flex items-center">-->
<!--              <div-->
<!--                class="w-8 h-8 bg-theme-18 text-theme-9 flex items-center justify-center rounded-full"-->
<!--              >-->
<!--                <InboxIcon class="w-4 h-4" />-->
<!--              </div>-->
<!--              <div class="ml-3">Mail Settings</div>-->
<!--            </a>-->
<!--            <a href class="flex items-center mt-2">-->
<!--              <div-->
<!--                class="w-8 h-8 bg-theme-17 text-theme-11 flex items-center justify-center rounded-full"-->
<!--              >-->
<!--                <UsersIcon class="w-4 h-4" />-->
<!--              </div>-->
<!--              <div class="ml-3">Users & Permissions</div>-->
<!--            </a>-->
<!--            <a href class="flex items-center mt-2">-->
<!--              <div-->
<!--                class="w-8 h-8 bg-theme-14 text-theme-10 flex items-center justify-center rounded-full"-->
<!--              >-->
<!--                <CreditCardIcon class="w-4 h-4" />-->
<!--              </div>-->
<!--              <div class="ml-3">Transactions Report</div>-->
<!--            </a>-->
<!--          </div>-->
<!--          <div class="search-result__content__title">Users</div>-->
<!--          <div class="mb-5">-->
<!--            <a-->
<!--              v-for="(faker, fakerKey) in $_.take($f(), 4)"-->
<!--              :key="fakerKey"-->
<!--              href-->
<!--              class="flex items-center mt-2"-->
<!--            >-->
<!--              <div class="w-8 h-8 image-fit">-->
<!--                <img-->
<!--                  alt="Midone Tailwind HTML Admin Template"-->
<!--                  class="rounded-full"-->
<!--                  :src="require(`@/assets/images/${faker.photos[0]}`)"-->
<!--                />-->
<!--              </div>-->
<!--              <div class="ml-3">{{ faker.users[0].name }}</div>-->
<!--              <div-->
<!--                class="ml-auto w-48 truncate text-gray-600 text-xs text-right"-->
<!--              >-->
<!--                {{ faker.users[0].email }}-->
<!--              </div>-->
<!--            </a>-->
<!--          </div>-->
<!--          <div class="search-result__content__title">Products</div>-->
<!--          <a-->
<!--            v-for="(faker, fakerKey) in $_.take($f(), 4)"-->
<!--            :key="fakerKey"-->
<!--            href-->
<!--            class="flex items-center mt-2"-->
<!--          >-->
<!--            <div class="w-8 h-8 image-fit">-->
<!--              <img-->
<!--                alt="Midone Tailwind HTML Admin Template"-->
<!--                class="rounded-full"-->
<!--                :src="require(`@/assets/images/${faker.images[0]}`)"-->
<!--              />-->
<!--            </div>-->
<!--            <div class="ml-3">{{ faker.products[0].name }}</div>-->
<!--            <div class="ml-auto w-48 truncate text-gray-600 text-xs text-right">-->
<!--              {{ faker.products[0].category }}-->
<!--            </div>-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- END: Search -->
    <!-- BEGIN: Notifications -->
    <div class="intro-x dropdown relative mr-auto sm:mr-6">
      <div
        class="dropdown-toggle notification notification--bullet cursor-pointer"
      >
        <BellIcon class="notification__icon dark:text-gray-300" />
      </div>
      <div class="notification-content pt-2 dropdown-box">
        <div
          class="notification-content__box dropdown-box__content box dark:bg-dark-6"
        >
          <div class="notification-content__title">Notifications</div>
          <div
            v-for="(n, i) in notifications"
            :key="n.id"
            class="cursor-pointer relative flex items-center"
            :class="{ 'mt-5': i }"
          >
            <div class="w-12 h-12 flex-none image-fit mr-1">
              <img
                alt="Midone Tailwind HTML Admin Template"
                class="rounded-full"
                style="background-color: #1C3FAA"
                :src="require(`@/assets/images/profile-1.jpg`)"
              />
              <div
                class="w-3 h-3 bg-theme-9 absolute right-0 bottom-0 rounded-full border-2 border-white"
              ></div>
            </div>
            <div class="ml-2 overflow-hidden">
              <div class="flex items-center">
                <a href="javascript:;" class="font-medium truncate mr-5">
                  {{ n.title }}
                </a>
                <div class="text-xs text-gray-500 ml-auto whitespace-no-wrap">
                  {{ n.time }}
                </div>
              </div>
              <div class="w-full truncate text-gray-600">
                {{ n.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Notifications -->
    <!-- BEGIN: Account Menu -->
    <div class="intro-x dropdown w-8 h-8 relative">
      <div
        class="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in"
      >
        <img
          alt="Midone Tailwind HTML Admin Template"
          :src="require(`@/assets/images/user.png`)"
        />
      </div>
      <div class="dropdown-box w-56">
        <div
          class="dropdown-box__content box bg-theme-38 dark:bg-dark-6 text-white"
        >
          <div class="p-4 border-b border-theme-40 dark:border-dark-3">
            <div class="font-medium">{{ userInfo.email }}</div>
            <div class="text-xs text-theme-41 dark:text-gray-600">
              Trainer
            </div>
          </div>
<!--          <div class="p-2">-->
<!--&lt;!&ndash;            <a&ndash;&gt;-->
<!--&lt;!&ndash;              href&ndash;&gt;-->
<!--&lt;!&ndash;              class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"&ndash;&gt;-->
<!--&lt;!&ndash;            >&ndash;&gt;-->
<!--&lt;!&ndash;              <UserIcon class="w-4 h-4 mr-2" /> Profile&ndash;&gt;-->
<!--&lt;!&ndash;            </a>&ndash;&gt;-->
<!--&lt;!&ndash;            <a&ndash;&gt;-->
<!--&lt;!&ndash;              href&ndash;&gt;-->
<!--&lt;!&ndash;              class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"&ndash;&gt;-->
<!--&lt;!&ndash;            >&ndash;&gt;-->
<!--&lt;!&ndash;              <EditIcon class="w-4 h-4 mr-2" /> Add Account&ndash;&gt;-->
<!--&lt;!&ndash;            </a>&ndash;&gt;-->
<!--            <div-->
<!--              class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md cursor-pointer"-->
<!--            >-->
<!--              <LockIcon class="w-4 h-4 mr-2" /> Change Password-->
<!--            </div>-->
<!--&lt;!&ndash;            <a&ndash;&gt;-->
<!--&lt;!&ndash;              href&ndash;&gt;-->
<!--&lt;!&ndash;              class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"&ndash;&gt;-->
<!--&lt;!&ndash;            >&ndash;&gt;-->
<!--&lt;!&ndash;              <HelpCircleIcon class="w-4 h-4 mr-2" /> Help&ndash;&gt;-->
<!--&lt;!&ndash;            </a>&ndash;&gt;-->
<!--          </div>-->
          <div class="p-2 border-t border-theme-40 dark:border-dark-3">
            <div
                @click="logout"
              class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md cursor-pointer"
            >
              <ToggleRightIcon class="w-4 h-4 mr-2" />
              Logout
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Account Menu -->
  </div>
  <!-- END: Top Bar -->
</template>

<script>
export default {
  data() {
    return {
      notifications: [
        {id: 1, name: "Your dashboard has been created!", time: "12:00AM", title: "Welcome"}
      ],
      userInfo: {},
      searchDropdown: false
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("ctoken")
      this.$router.push({name:"login"})
    },
    getUserInfo() {
      this.$upskill.consInfo().then(res => {
        this.userInfo = res.data;
      }).catch(() => {
        localStorage.removeItem("ctoken")
        this.$router.push({name:"login"})
      })
    },
    showSearchDropdown() {
      this.searchDropdown = true;
    },
    hideSearchDropdown() {
      this.searchDropdown = false;
    }
  },
  created() {
    this.getUserInfo();
  }
};
</script>
